// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1048":"4cd1d3a0989db2d8","1077":"1c99f161ea08453f","3996":"6c9ef5232bc12b1c"}[chunkId] + ".css";
};